import type { RedemptionResult } from '../types';

export interface RedemptionPresentation {
  label: string;
  title: string;
  description: string;
  icon: 'pending' | 'success' | 'error';
  canNavigate: boolean;
}

export function redemptionPresentation(
  status: RedemptionResult['status'],
  companyName: string,
): RedemptionPresentation {
  if (status === 'ACTIVATED') {
    return {
      label: 'Conexión confirmada',
      title: 'Ya tienes internet.',
      description: `Todo listo. Disfruta tu viaje con ${companyName}.`,
      icon: 'success',
      canNavigate: true,
    };
  }
  if (status === 'FAILED') {
    return {
      label: 'Activación interrumpida',
      title: 'No pudimos completar la conexión.',
      description: 'Puedes intentarlo otra vez o pedir ayuda a la tripulación.',
      icon: 'error',
      canNavigate: false,
    };
  }
  return {
    label: 'Conectando',
    title: 'Espera un momento.',
    description: 'Estamos preparando tu acceso a internet.',
    icon: 'pending',
    canNavigate: false,
  };
}
